import React from "react";
import '../Page/css/About.css'

function About() {
    return(
        <div id="about" className="AboutTop">
            Profile
        </div>
    )
}

export default About;